import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-myaccount',
  templateUrl: './myaccount.component.html',
  styleUrls: ['./myaccount.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MyaccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
